import { render, staticRenderFns } from "./UpholsteryTop.vue?vue&type=template&id=28575554&scoped=true"
import script from "./UpholsteryTop.vue?vue&type=script&lang=js"
export * from "./UpholsteryTop.vue?vue&type=script&lang=js"
import style0 from "./UpholsteryTop.vue?vue&type=style&index=0&id=28575554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28575554",
  null
  
)

export default component.exports